// Configuración temporal del usuario para desarrollo
// Este archivo se puede eliminar cuando se implemente la autenticación real

export const USER_CONFIG = {
  // Email del usuario para desarrollo
  FORCE_EMAIL: 'fmarin@zentrik.eu',
  
  // Nombre del usuario
  FORCE_NAME: 'Francisco Marín',
  
  // Rol del usuario
  FORCE_ROLE: 'admin',
  
  // ID de la empresa
  FORCE_COMPANY_ID: 1,
  
  // Forzar el uso de esta configuración
  FORCE_USE_CONFIG: true
}

export default USER_CONFIG
